export default class Api {

    static getAppCheckHeaders(token) {
        return token ? {'X-Firebase-AppCheck': token} : {};
    }

    static fetchItems = async (auth, keywords, category, sort, page, entries, minPrice, maxPrice, listingTypes, currency, blockedSellers, blockedCountries, controller, countryCode, cached, next) => {
        // console.log(`fetching ${page}...`);
        let token = await auth.getAppToken();
        let url = this.getItemsUrl(keywords, category, sort, page, entries, minPrice, maxPrice, listingTypes, currency, blockedSellers, blockedCountries, countryCode, cached, next);
        return fetch(url, {
            signal: controller?.signal,
            headers: this.getAppCheckHeaders(token)
        })
            .then((res) => res.json());
    }

    static getItemsUrl(keywords, category, sort, page, entries, minPrice, maxPrice, listingTypes, currency, blockedSellers, blockedCountries, countryCode, cached, next) {
        let url = `/${next ? "next-page" : `search${cached ? "-cached" : ""}`}?keywords=${keywords}&category=${category}&sort=${sort}&page=${page}&entries=${entries}`;
        if (minPrice) {
            url += `&minPrice=${minPrice}`
        }
        if (maxPrice) {
            url += `&maxPrice=${maxPrice}`
        }
        if (currency) {
            url += `&currency=${currency}`
        }
        if (countryCode) {
            url += `&countryCode=${countryCode}`
        }
        if (listingTypes) {
            if (Array.isArray(listingTypes)) {
                let o = listingTypes.length;
                for (let i = 0; i < o; i++) {
                    url += `&listingTypes=${listingTypes[i]}`;
                }
            } else {
                url += `&listingTypes=${listingTypes}`;
            }
        }
        if (blockedSellers) {
            if (Array.isArray(blockedSellers)) {
                let l = blockedSellers.length;
                for (let i = 0; i < l; i++) {
                    url += `&blockedSeller=${blockedSellers[i]}`;
                }
            } else {
                url += `&blockedSeller=${blockedSellers}`;
            }
        }
        if (blockedCountries) {
            if (Array.isArray(blockedCountries)) {
                let l = blockedCountries.length;
                for (let i = 0; i < l; i++) {
                    url += `&blockedCountries=${blockedCountries[i]}`;
                }
            } else {
                url += `&blockedCountries=${blockedCountries}`;
            }
        }
        return url;
    }

    static fetchItem = async (auth, id, controller) => {
        // console.log(`fetching ${id}...`);
        let token = await auth.getAppToken();
        return fetch(`/get-item?id=${id}`, {
            signal: controller?.signal,
            headers: this.getAppCheckHeaders(token)
        })
            .then((res) => res.json())
            .catch(e => {
                throw(e);
            });
    }

    static fetchRecentItem = async (auth, id, controller) => {
        let token = await auth.getAppToken();
        return fetch(`/get-recent-item?id=${id}`, {
            signal: controller?.signal,
            headers: this.getAppCheckHeaders(token)
        })
            .then((res) => {
                if (!res.ok) throw new Error(`Unable to fetch recent item (${res.status})`);
                return res.json();
            })
            .catch(e => {
                throw(e);
            });
    }

    static fetchTopSearches = async (auth, controller) => {
        let token = await auth.getAppToken();
        return fetch(`/get-top-searches`, {
            signal: controller?.signal,
            headers: this.getAppCheckHeaders(token)
        })
            .then((res) => res.json())
            .catch(e => {
                throw(e);
            });
    }

    static updateRecents = async (auth, id) => {
        const idToken = await auth.user?.getIdToken();
        if (idToken) {
            fetch(`/update-recents?id=${id}`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({idToken: idToken})
            }).catch(e => {
            });
        }
    }

    static fetchCategories = async (auth, keywords, countryCode, controller) => {
        // console.log(`fetching category for ${keywords}...`);
        let token = await auth.getAppToken();
        return fetch(`/get-categories?keywords=${keywords}`, {
            signal: controller.signal,
            headers: this.getAppCheckHeaders(token)
        })
            .then((res) => res.json())
            .catch(e => {
                throw 'Server error'
            });
    }

    static fetchVersion = async () => {
        return fetch("/version")
            .then((res) => res.json());
    }

}